import React from "react";

export default function LegalTokushoho() {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:64px_64px]" />
      
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="bg-card/80 backdrop-blur-md border border-border/50 rounded-3xl p-8 shadow-2xl ring-1 ring-white/10">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h1 className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent text-3xl font-bold">
              特定商取引法に基づく表記
            </h1>
            <p className="text-muted-foreground mt-2">販売事業者情報</p>
          </div>

          <div className="prose prose-invert max-w-none">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              <div className="bg-accent/50 rounded-lg p-4">
                <dt className="font-semibold text-foreground">販売事業者</dt>
                <dd className="text-foreground">Surphin</dd>
              </div>
              <div className="bg-accent/50 rounded-lg p-4">
                <dt className="font-semibold text-foreground">運営責任者</dt>
                <dd className="text-foreground">川上慶悟</dd>
              </div>
              <div className="bg-accent/50 rounded-lg p-4">
                <dt className="font-semibold text-foreground">所在地</dt>
                <dd className="text-foreground">〒104-0061 東京都中央区銀座1丁目12番4号N&E BLD.6F</dd>
              </div>
              <div className="bg-accent/50 rounded-lg p-4">
                <dt className="font-semibold text-foreground">メール</dt>
                <dd className="text-foreground">customer-support-cashless@cashlessmap.com</dd>
              </div>
              <div className="bg-accent/50 rounded-lg p-4 md:col-span-2">
                <dt className="font-semibold text-foreground mb-2">URL</dt>
                <dd className="text-foreground mb-3">https://www.surphin.com</dd>
                <a
                  href="https://www.surphin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    backgroundColor: '#9333ea',
                    color: '#ffffff',
                    fontWeight: 600,
                    borderRadius: '8px',
                    textDecoration: 'none',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#7e22ce'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#9333ea'}
                >
                  公式HP
                </a>
              </div>
            </div>

            <h2 className="text-xl font-semibold text-foreground mb-4">商品・役務</h2>
            <p className="text-foreground">店舗向け情報掲載・管理サービス「Cashless Map」</p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">販売価格</h2>
            <p className="text-foreground">1店舗あたり <strong>月額 300円（税込）</strong></p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">代金以外の必要料金</h2>
            <p className="text-foreground">通信費等はお客様負担</p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">支払方法・時期</h2>
            <ul className="text-foreground space-y-2">
              <li>クレジットカード（Stripe）</li>
              <li>申込時即時／以降毎月同日に自動決済</li>
            </ul>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">提供時期</h2>
            <p className="text-foreground">決済完了後ただちに有効化</p>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">解約・キャンセル</h2>
            <ul className="text-foreground space-y-2">
              <li>管理画面の「支払い方法の変更」からいつでも解約可能</li>
              <li>日割り返金なし／提供後の返金不可</li>
            </ul>

            <h2 className="text-xl font-semibold text-foreground mb-4 mt-8">継続課金の停止・削除</h2>
            <p className="text-foreground">決済が<strong>3か月連続</strong>で失敗した場合、掲載店舗を自動削除します。</p>
          </div>
        </div>
      </div>
    </div>
  );
}
